//ng build --configuration="test"

export const environment = {
    VERSION : "10.4.0",
    ENV_NAME:'TEST',
    production: false,
    API_URL_CORE: 'https://dev.api.ft.embla.no',    
    IFRAME_URL:'https://dev.ft.embla.no',
    LEGACY_API_URL: 'https://dev.ftv10.embla.no/Client',
    WEB_SHOP_URL: "https://dev.shop.embla.no/",
    WEB_SHOP_MEMBERSHIP_URL: "https://dev.shop.embla.no/{0}/medlemskap",
    WEB_SHOP_V10_MEMBERSHIP_URL: "https://dev.shop.embla.no/{0}/versjon10ogmedlemskap",
    EMBLA_V9_URL: "https://dev.ft9.embla.no",
    FT_HELP_URL: "https://dev.help.embla.no",
    FT_HELP_URL_API: 'https://dev.api.help.embla.no/api/v1',
    FT_AUTH_URL: "https://dev.auth.embla.no",
    FT_PRODUCT_PAGE_URL: "https://dev.embla.no",
    FT_SUPPORT_URL: "https://dev.ft9.embla.no/Support/Support",
    FT_SHOP_API_URL: "https://api.shop.dev.embla.no",
    SUPPORT_ARTICLE_URL:'https://dev.help.embla.no/',
    LOADER_TIMEOUT_MINUTES: 3,
    RELOAD_FREQUENCE: 10,
    ACCEPTED_IMAGE_FILE_TYPE: ["jpg","jpeg","bmp","tiff","png"],
    ACCEPTED_AUDIO_FILE_TYPE: ["wav","mp3","mpeg"],
    ACCEPTED_VIDEO_FILE_TYPE: ["mp4","avi"],
    ACCEPTED_DOCUMENTS_FILE_TYPE: ["msword","rtf","txt","pdf","plain", "doc"],
    ACCEPTED_IMAGE_FILE_SIZE: 5242880,
    ACCEPTED_VIDEO_FILE_SIZE: 15242880,
    CROP_SQURE_WIDTH: 260,
    DEFAULT_CULTURE: 'no',
    BREADCRUMB_SIZE: 4,
    HISTORY_LIST_SIZE: 10,
    CHROME_DOWNLOAD_URL: "https://www.google.com/chrome/",
    FAMILY_PROJECT_RELOAD_TIMEOUT: 5000, // 5 seconds
    BOOK_REPORT_DELAY_INFO_POPUP_TIMEOUT: 5000,
    TRIAL_EXPIRE_WARNING_RANGE: {
      "range_1": 30,
    },
    GEOCODE :{
      "url": "https://api.mapbox.com/geocoding/v5/mapbox.places/",
      "dataFormat": ".json",
      "mapboxAccessToken":"pk.eyJ1IjoiY2hhbmRpbWFsdyIsImEiOiJjbGYyMmNjazcwZWJ1M3NsajUzdm1hOGxsIn0.CY1vLBnEq-TOQcJ3qO__PA",
      "responseType": "Mapbox-Json",
      "googleAccessToken": "AIzaSyCTRZQGY2xZX1EoSoyo8eZz72JZE83uj_Q"
    },
    PLACE: {
      "openMapDelayTimeOut": 5500
    },
    BOOK_REPORT:{
      "dynamicPagePath":"D://Data-FT//Report//Test//Html",
      "templatePath":"D://Data-FT//Report//Test//Templates"
    },
    DOMAIN:'embla.no',
    DUPLICATE_VALIDATION_EVENTS: ["BIRTH", "DEATH","MARRIAGE"],
    IS_INDEXED_DB_ENABLED:false,
    TREE_LEVEL : 5,
    CONTACT_FORM: {
      FILE_ATTACHMENTS: {
        FILE_TYPES: ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'gif', 'txt'],
        MAX_SIZE: 5 * 1024 * 1024, // 5MB in bytes 
        MAX_COUNT: 5
      },
      SUBJECT_MAX_LENGTH: 100,
      MESSAGE_MAX_LENGTH: 1000,
      EMAIL_PATTERN: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
      ADDITIONAL_CATEGORIES: ["other"]
    },
    CHAT_WIDGET:{
    "accesskey":"nEdVIBdLgWbzrggLVMQanr6CxKic8MDZ",
    "scriptSrc":'https://dev.eha.embla.lk/chat-widget.min.js'
    },
    SUPPORT_BASE_URL: 'https://dev.api.help.embla.no/api/v1',
    DASHBOARD: {
    YOUTUBE_VIDEO_URL: 'https://www.youtube.com/embed/_QxpEfPq7B0',
    FACEBOOK_PAGE_URL: 'https://www.facebook.com/emblanorskfamiliehistorie',
    YOUTUBE_PAGE_URL: 'https://www.youtube.com/@EmblaNorskFamiliehistorie',
    PRIVACY_POLICY_URL_EN: 'https://dev.embla.no/assets/Content/privacy-policy/en',
    PRIVACY_POLICY_URL_NO: 'https://dev.embla.no/assets/Content/privacy-policy/no'
  }
};
